import { render } from "./api-rule.vue?vue&type=template&id=7e17b067&scoped=true"
import script from "./api-rule.vue?vue&type=script&lang=js"
export * from "./api-rule.vue?vue&type=script&lang=js"

import "./api-rule.vue?vue&type=style&index=0&id=7e17b067&lang=less&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e17b067"]])

export default __exports__